export const demoOptions = [
  {
    link: '/enter-phone-number',
    name: 'EnterPhoneNumber',
  },
  {
    link: '/landing',
    name: 'LandingHelp',
  },
  {
    link: '/help-signature-draw-pad',
    name: 'HelpSignatureDrawPad',
  },
  {
    link: '/signature-draw-pad',
    name: 'SignatureDrawPad',
  },
  {
    link: '/verify-phone-number',
    name: 'VerifyPhoneNumber',
  },
  {
    link: '/national-code',
    name: 'NationalCode',
  },
  {
    link: '/sheba-number',
    name: 'ShebaNumber',
  },
  {
    link: '/location-information',
    name: 'LocationInformation',
  },
  {
    link: '/complete-user-info',
    name: 'CompleteUserInfo',
  },
  {
    link: '/complete-identify-information',
    name: 'CompleteIdentityInformation',
  },
  {
    link: '/national-card-serial',
    name: 'NationalCardSerialInformation',
  },
  {
    link: '/success-payment',
    name: 'SuccessPayment',
  },
  {
    link: '/field-payment',
    name: 'FieldPayment',
  },
  {
    link: '/no-payment',
    name: 'NoPayment',
  },
  {
    link: '/information-confirmed',
    name: 'InformationConfirmed',
  },
  {
    link: '/information-waiting',
    name: 'InformationWaiting',
  },
  {
    link: '/no-face-matching',
    name: 'NoFaceMatching',
  },
  {
    link: '/face-recognition-recording',
    name: 'FaceRecognitionRecording',
  },
  {
    link: '/take-picture-national-card-front',
    name: 'nationalFront',
  },
  {
    link: '/take-picture-national-card-back',
    name: 'nationalBack',
  },
  {
    link: '/take-picture-signature',
    name: 'Signature',
  },
  {
    link: '/video-confirmed',
    name: 'VideoConfirmed',
  },
  {
    path: '/confirm-info',
    element: 'ConfirmInfo',
  },
];

export const confirmLicensePersonalityInformation = [
  { title: 'نام صنف', name: 'name', id: 1 },
  { title: 'عنوان صنف', name: 'title', id: 2 },
  { title: 'تاریخ اعتبار', name: 'expiredAt', id: 3 }
];

export const confirmUserInformation = [
  { title: 'نام و نام خانوادگی', name: 'name', id: 1 },
  { title: 'تاریخ تولد', name: 'birthdate', id: 2 },
  { title: 'نام پدر', name: 'fatherName', id: 3 },
];

export const confirmCarInformation = [
  // { title: 'رنگ خودرو', name: 'carColor', id: 1 },
  { title: 'مدل خودرو', name: 'carType', id: 1 },
  { title: 'نوع خودرو', name: 'carSystem', id: 2 },
  { title: 'تاریخ تولید خودرو', name: 'carModel', id: 3 },
  // { title: 'تاریخ نصب پلاک', name: 'plateInstallDate', id: 3 },
];
export const DEMO_ITEM_HEIGHT = 48;

export const PERSIAN_CALENDAR = 'persian-calendar';
export const RANDOM_STRING = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const SANA_TYPE = 'sana';
export const DIVAR_TYPE = 'divar';
export const DIVAR_ELIGIBILITY_TYPE = 'divarEligibility';
export const DIVAR_Discount_Payment_TYPE = 'divarDiscountPayment';
export const EITTA_TYPE = 'eitta';
export const SNAP_SHOP_TYPE = 'snap-shop';
export const SNAP_SHOP_PRODUCTION_TYPE = 'snap-shop-production';
export const FATA_TYPE = 'fata';
export const BALE_TYPE = 'bale';
export const SOROUSH_TYPE = 'soroush';
export const SOROUSH_PLUS_PRODUCTION_TYPE = 'soroush_plus_production';
export const UID_TYPE = 'uid';
export const CENTRAL_BANK_TYPE = 'centralBank';

export const NEXT_STEP_URI = 'nextStepURI';
export const NEXT_STEP_TOKEN = 'nextStepToken';

export const DIVAR_REFERRAL_NAME = 'DIVAR';
export const DIVAR_CAR_REFERRAL_NAME = 'DIVAR_CAR_INFO';
export const CRIMINAL_RECORD_REFERRAL_NAME = 'CRIMINAL_RECORD';
export const EITTA_REFERRAL_NAME = 'EITTA';
export const SNAP_SHOP_REFERRAL_NAME = 'SNAP_SHOP';
export const SNAP_SHOP_PRODUCTION_REFERRAL_NAME = 'SNAP_SHOP_PRODUCTION';
export const FATA_REFERRAL_NAME = 'FATA';
export const BALE_REFERRAL_NAME = 'BALE';
export const SOROUSH_REFERRAL_NAME = 'SOROUSH';
export const SOROUSH_PLUS_PRODUCTION_REFERRAL_NAME = 'SOROUSH';
export const SIMPLIFIED_REFERRAL_NAME = 'SIMPLIFIED_UI';
export const OKAYESH_SIMPLIFIED_REFERRAL_NAME = 'okayesh-simplified-uid';
export const ASIA_TECH_SIMPLIFIED_REFERRAL_NAME = 'asia-tech-simplified-ui';
export const MASIR_POUYA_JOUYAN_ARAS_SIMPLIFIED_REFERRAL_NAME = 'masir-pouya-jouyan-aras-simplified-ui';
export const MAHKAMYAR_REFERRAL_NAME = 'MAHKAMYAR_UI';
export const NAJI_REFERRAL_NAME = 'NAJI_UI';
export const AZKI_REFERRAL_NAME = 'AZKI';
export const GHESTA_REFERRAL_NAME = 'GHESTA_UI';
export const IRANI_CARD_REFERRAL_NAME = 'IRANI_CARD_UI';
export const BUSINESS_LICENSE_REFERRAL_NAME = 'DIVAR_BUSINESS_LICENSE';
export const CENTRAL_BANK_REFERRAL_NAME = 'CENTRAL_BANK';
export const UID_REFERRAL_NAME = 'UID';

// This is for default value
export const SIMPLIFIED_REDIRECT_URL = 'https://google.com/';
export const DIVAR_REDIRECT_URL = 'https://divar.ir/my-divar/my-posts';
export const EITTA_REDIRECT_URL = 'https://my.eitaa.com/api/v1/verification/result/uid';
export const SNAP_SHOP_REDIRECT_URL = 'https://snappshop.ir';
export const SNAP_SHOP_PRODUCTION_REDIRECT_URL = 'https://snappshop.ir';
export const BALE_REDIRECT_URL = 'https://ble.ir/ban';
export const SOROUSH_REDIRECT_URL = 'https://splus.ir';
export const SOROUSH_PLUS_PRODUCTION_REDIRECT_URL = 'https://auth.splus.ir/api/v1/auth/uid/redirect';
export const FATA_REDIRECT_URL = 'https://google.com';
export const CENTRAL_BANK_REDIRECT_URL = 'https://ex-user.exirr.ir';
export const UID_REDIRECT_URL = 'https://u-id.net';

export const DIVAR_META_DATA_POST_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON =
  'DIVAR_META_DATA_POST_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON';
export const DIVAR_META_DATA_POST_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON =
  'DIVAR_META_DATA_POST_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON';
export const DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON =
  'DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITH_IMAGE_PROFILE_ADDON';
export const DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON =
  'DIVAR_META_DATA_PROFILE_IDENTIFICATION_WITHOUT_IMAGE_PROFILE_ADDON';
